import { Formik } from "formik";
import React, { useState } from "react";
import { Col, Row, Container } from "reactstrap";
import images from "../../assets/images";
import { Input, Loader } from "../../components";
import { getLocalization } from "../../redux/localization";
import { useDispatch, useSelector } from "react-redux";
import { createContact } from "../../redux/homepage/saga";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { appUrl } from "../../redux/base/types/url";
import { useLocation } from "react-router-dom";
import { languagesSelector } from "../../redux/languages";

const ContactUs = () => {
  const [loader, setLaoder] = useState(false);
  const t = useSelector(getLocalization);
  const dispatch = useDispatch();
  const location = useLocation();
  const title = t.getString("ContactUsSeoTitle");
  const desc = t.getString("ContactUsSeoDescription");
  const languages = useSelector(languagesSelector);
  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        {/* <link
          rel="alternate"
          hrefLang="x-default"
          href={appUrl + "/contactus"}
        />
        {languages.map((x) => {
          let code = x.Code.split("-")[0];
          return (
            <link
              rel={code === "en" ? "canonical" : "alternate"}
              hrefLang={code}
              href={appUrl + "/" + code + "/contactus"}
            />
          );
        })} */}
        <title>Contact Rentificial | Get Support or Schedule a Demo</title>
<meta name="description" content="Need help or want to explore Rentificial’s rental software? Contact us today for personalized support or a product demo." />
<meta name="keywords" content="contact Rentificial, rental software support, car rental software demo, customer service Rentificial" />
<link rel="canonical" href="https://www.rentificial.com/contactus/" />

        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={title} />
        <meta name="twitter:card" content={"large_summary_card"} />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={images.logoColored} />
        <meta property="og:url" content={appUrl + location.pathname} />

      </Helmet>
      <Container>
        {loader && <Loader />}
        <div className="page-content defaultPage">
          <h2 className=" text-center">{t.getString("Contact Us")}</h2>
          
          <Row className="mb-12 ">
  <Col md={12} >
    <h1>Let’s Talk About Your Car Rental Software Needs</h1>
    <p className=" text-left">
      We’re here to support you at every stage of your rental journey. Whether you're exploring Rentificial for the first time, need help setting up your car rental software, or have specific questions about your account — our team is ready to assist.
      <br /><br />
      At Rentificial, we understand that managing rentals comes with its own set of complexities. That’s why we offer more than just a platform — we offer partnership. Our support team is available to provide personalized guidance tailored to your fleet size, rental goals, and technical environment.
      <br /><br />
      If you're unsure which features are best for your business, need help customizing your settings, or want to schedule a live demo, just let us know. We’re happy to walk you through the smart tools that make Rentificial a preferred solution among global rental operators.
      <br /><br />
      ✅ Need help choosing the right modules? <br />
      ✅ Curious about how our car rental software simplifies operations? <br />
      ✅ Want to see Rentificial in action?
      <br /><br />
      You’re in the right place.
      <br /><br />
      Use the form on this page to contact us directly. A member of our support or sales team will reach out shortly. No question is too big or too small — we’re committed to helping you make the most of Rentificial.
      <br /><br />
      Let’s simplify rental management together. We look forward to hearing from you!
    </p>
  </Col>
</Row>


          <Row className="py-5">
            <Col md={6}>
              <Formik
                initialValues={{
                  Name: "",
                  Surname: "",
                  Email: "",
                  Message: "",
                  Phone: "",
                }}
                onSubmit={(values: any, { resetForm }: any) => {
                  setLaoder(true);
                  dispatch(
                    createContact({
                      payload: {
                        onSuccess: () => {
                          setLaoder(false);
                          resetForm();
                          return toast.success(
                            t.getString(
                              "Your contact request has been received We will contact you as soon as possible"
                            )
                          );
                        },
                        onError: () => {},
                      },
                      body: values,
                    })
                  );
                }}
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => {
                  return (
                    
                    <Row className="contactUsForm">
                      <Col md={12}>
                        <Input
                          placeholder={t.getString(`Name`)}
                          onChange={handleChange("Name")}
                          onBlur={handleBlur("Name")}
                          error={errors.Name}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          placeholder={t.getString(`Surname`)}
                          onChange={handleChange("Surname")}
                          onBlur={handleBlur("Surname")}
                          error={errors.Surname}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          placeholder={t.getString("Email")}
                          onChange={handleChange("Email")}
                          onBlur={handleBlur("Email")}
                          error={errors.Email}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          placeholder={t.getString("Phone")}
                          onChange={handleChange("Phone")}
                          onBlur={handleBlur("Phone")}
                          error={errors.Phone}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          placeholder={t.getString(`Message`)}
                          onChange={handleChange("Message")}
                          onBlur={handleBlur("Message")}
                          error={errors.Message}
                        />
                      </Col>
                      <Col md={12}>
                        <button
                          className="primaryButton mt-2"
                          style={{ width: "100%" }}
                          onClick={() => handleSubmit()}
                        >
                          {t.getString("Send Message")}
                        </button>
                      </Col>
                    </Row>
                  );
                }}
              </Formik>
            </Col>
            <Col md={6} className="contactUsInfo">
              <img
                src={images.contact}
                alt="Rentificial Contact"
                width={"100%"}
              />
              <Row className="mt-5">
                <Col md={7}>
                  <h3>{t.getString("Our Location")}</h3>
                  <p className=" text-left">
                    Zümrütevler, Ural Sk. 14/3, 34852 Maltepe/İstanbul
                  </p>
                </Col>
                <Col md={5}>
                  <h3>{t.getString("Email")}</h3>
                  <p className=" text-left">info@rentificial.com</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};
export default ContactUs;
